"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_NODE_GUIDELINES = void 0;
const gql_1 = require("../../../../../__generated__/gql");
exports.GET_NODE_GUIDELINES = (0, gql_1.gql)(`
  query NodeGuidelines(
    $productTreeNodeId: ID!,
    $label: String!,
    $first: Int,
    $after: ID,
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      title
      description
      labelValidation(filter: { some: { label: { equals: $label } } }) {
        edges {
          node {
            label
            description
            values(first: $first, after: $after) {
              totalCount
              pageInfo {
                endCursor
                startCursor
                hasNextPage
                hasPreviousPage
              }
              edges {
                node {
                  value
                  description
                }
              }
            }
          }
        }
      }
    }
  }
`);
